import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortcutNumbers',
    standalone: false
})
export class ShortcutNumbersPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    if (value !== null) {
      value = Math.round(value);
      if (value < 1000) {
        return value;
      } else if (value < 1000000) {
        return Math.round(value / 100) / 10 + 'K';
      } else if (value >= 1000000) {
        return Math.round(value / 100000) / 10 + 'MLN';
      } else if (value >= 1000000000) {
        return Math.round(value / 100000000) / 10 + 'MLD';
      }
    }

    return value;
  }

}
